import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { URLS } from "../../constants/settings";
import logger from "../../utils/logger";

const GoogleOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const setCookies = async (email: string) => {
    try {
      const codeChallenge = Cookies.get("code_challenge");
      const port = Cookies.get("port");
      const redirectUri = Cookies.get("redirect_uri");
      const state = Cookies.get("state");

      const response = await axios.post(
        `${URLS.CLIENT_URL}/api/auth/google/complete-login`,
        {
          email: email,
          codeChallenge: codeChallenge,
          redirectUri: redirectUri,
          state: state,
          port: port,
        },
      );

      const userData = response.data?.data || response.data || response;
      localStorage.setItem("authUser", JSON.stringify(userData));
    } catch (error) {
      logger.error("Error completing google login");
    } finally {
      Cookies.remove("code_challenge");
      Cookies.remove("port");
      Cookies.remove("redirect_uri");
      Cookies.remove("state");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
    const email = params.get("email");
    const firstName = params.get("firstName");
    const lastName = params.get("lastName");
    const role = params.get("role");
    const language = params.get("language");
    const companyID = params.get("companyID");
    const isLogin = params.get("isLogin");

    if (isLogin == "true" && email) {
      setCookies(email)
        .then(() => {
          navigate("/channel-session");
        })
        .catch((error) => {
          logger.error("Error completing google login");
        });
      return;
    }

    if (id && email && firstName) {
      const authUser = {
        ID: id,
        Email: email,
        FirstName: firstName,
        LastName: lastName || "",
        CompanyID: companyID || "",
        CompanyName: "",
        Gender: "",
        Role: role || "admin",
        Subscription: "",
        Language: language || "",
        Telephone: "",
      };

      localStorage.setItem("authUser", JSON.stringify(authUser));

      Cookies.set("api-key", "temp-onboarding-" + id, { expires: 7 });

      navigate("/onboarding");
    } else {
      logger.error("Dados do utilizador em falta no callback do Google.");
      navigate("/auth-login?error=true");
    }
  }, [location, navigate]);

  return (
    <div>
      <p>A preparar a sua conta, por favor aguarde...</p>
    </div>
  );
};

export default GoogleOnboarding;
